import { styled } from '@mui/system';
import { Box, Typography } from '@mui/material';

export const Breadcrumb = styled(Box)({
  display    : 'flex',
  alignItems : 'center',
  gap        : '10px',

  a : {
    textDecoration : 'none',
  },
});

export const HeatMapWrapper = styled(Box)(({ theme }) => ({
  width        : '100%',
  padding      : '25px 40px',
  background   : theme.palette.primary.white,
  border       : `1px solid ${theme.palette.primary.gray3}`,
  borderRadius : '10px',
  height       : '500px',

  svg : {
    display : 'block',
    margin  : '20px auto 0 auto',
  },
}));

export const Card = styled(Box)(({ theme }) => ({
  position     : 'relative',
  padding      : '25px 40px',
  height       : '311px',
  maxHeight    : '311px',
  background   : theme.palette.primary.white,
  border       : `1px solid ${theme.palette.primary.gray3}`,
  borderRadius : '10px',
}));

export const Percentage = styled(Typography)(({ theme }) => ({
  position   : 'absolute',
  top        : '50%',
  left       : '50%',
  transform  : 'translate(-50%, -50%)',
  fontSize   : '62px',
  color      : theme.palette.primary.blue1,
  fontFamily : 'Montserrat',
}));
